import { useMemo } from "react";

import {
  CRYPTO_TIME_IN_FORCE_OPTIONS,
  type CryptoOrderType,
  type CryptoTimeInForce,
} from "~/v2/constants/cryptoOrder";

interface GetCryptoTimeInForceOptionsParams {
  orderType: CryptoOrderType;
}

export const getCryptoTimeInForceOptions = ({
  orderType,
}: GetCryptoTimeInForceOptionsParams): {
  label: string;
  subLabel?: string;
  value: CryptoTimeInForce;
}[] =>
  CRYPTO_TIME_IN_FORCE_OPTIONS.filter((option) =>
    option.orderTypes.includes(orderType),
  ).map(({ label, subLabel, value }) => ({ label, subLabel, value }));

export const useCryptoTimeInForceOptions = ({
  orderType,
}: GetCryptoTimeInForceOptionsParams) => {
  const timeInForceOptions = useMemo(
    () => getCryptoTimeInForceOptions({ orderType }),
    [orderType],
  );

  return { timeInForceOptions };
};
